// extracted by mini-css-extract-plugin
module.exports = {"account":"AccountMenu_account__R9XAh"};